import React from 'react'
import { useSelector } from 'react-redux'

import { REGISTRATION_VIEW_ENUM, selectSelectedRegistrationView } from 'state/review'
import SimpleTable from '../Submissions/SimpleTable'
import WaitlistTable from '../Submissions/WaitlistTable'

interface RegistrationsContainerProps {
    tableHeight: string
}

const RegistrationsContainer: React.FC<RegistrationsContainerProps> = ({ tableHeight }) => {
    const registrationView = useSelector(selectSelectedRegistrationView)

    if (!registrationView) return null
    return registrationView == REGISTRATION_VIEW_ENUM.WAITLISTED ? (
        <WaitlistTable viewType={registrationView} />
    ) : (
        <SimpleTable viewType={registrationView} tableHeight={tableHeight} />
    )
}

export default RegistrationsContainer
